import { render, staticRenderFns } from "./RequestNewCardConfirmForm.vue?vue&type=template&id=b9cfe8a4"
import script from "./RequestNewCardConfirmForm.vue?vue&type=script&lang=ts"
export * from "./RequestNewCardConfirmForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports